<template>

        <div class="container donate__section">
            <div class="row donation-form-container flex-column-reverse flex-md-row">
                <div id="donating" class="col-md-5 donate__content">
                    <h2>Ja, ik wil een donatie doen</h2>
                    <form id="donating-form" class="donate__form" ref="donating-form" action="/create-donation" method="post" @submit.prevent="validateForm">

                        <dropdown ref="dropdown" :options="dropdownOptions" placeholder="Kies een bedrag" v-on:dropdownChange="checkAmountValue()"></dropdown>

                        <input type="hidden" name="amount" :value="formData.amount">
                        <div class="donate__form__text donate__form--w-100"
                             v-show="showExtraAmount">
                            <input class="green-border" type="text" placeholder="Uw bedrag"
                                   name="extra-amount"
                                   @keypress="isNumber($event)"
                                   v-model="formData.extraAmount"
                                   v-bind:class="{error : formErrors.extraAmount != null}">
                        </div>
                        <div class="donate__form__text donate__form--w-100">
                            <input type="text" v-model="formData.name" name="name" v-bind:class="{error : formErrors.name != null}" placeholder="Voornaam">
                        </div>
                        <div class="donate__form__text donate__form--w-100">
                            <input type="text" v-model="formData.surname" name="surname" v-bind:class="{error : formErrors.surname != null}"  placeholder="Achternaam">
                        </div>
                        <div class="donate__form__text donate__form--w-100">
                            <input type="text" v-model="formData.address" name="address" v-bind:class="{error : formErrors.address != null}"  placeholder="Adres">
                        </div>
                        <div class="donate__form__text donate__form--w-100">
                            <input type="text" v-model="formData.zipcode" name="zipcode" v-bind:class="{error : formErrors.zipcode != null}"  placeholder="Postcode">
                        </div>
                        <div class="donate__form__text donate__form--w-50">
                            <input type="text" name="number" v-model="formData.number" v-bind:class="{error : formErrors.number != null}"  placeholder="Huisnummer">
                        </div>
                        <div class="donate__form__text donate__form--w-50">
                            <input type="text" name="addition" v-model="formData.addition" v-bind:class="{error : formErrors.addition != null}"  placeholder="Toevoeging">
                        </div>
                        <div class="donate__form__text donate__form--w-100">
                            <input type="text" v-model="formData.residence" name="residence" v-bind:class="{error : formErrors.residence != null}"  placeholder="Woonplaats">
                        </div>
                        <div class="donate__form__text donate__form--w-100">
                            <input type="text" v-model="formData.email" name="email" v-bind:class="{error : formErrors.email != null}"  placeholder="Email">
                        </div>
                        <div class="donate__form__text donate__form--w-100">
                            <input type="text" v-model="formData.phone" name="phone" v-bind:class="{error : formErrors.phone != null}"  placeholder="Telefoon">
                        </div>
                        <input type="hidden" name="_token" :value="formData._token">
                        <div class="donate__form__submit donate__form--w-100">
                            <input class="bg--tertiary hover-bg--quaternary" type="submit" value="DONEER HIER">
                            <p class="about__figure-caption family_section" style="text-align: center">
                                Door op "Doneer hier" te klikken gaat u </br> naar iDeal om uw donatie af te ronden.
                            </p>

                        </div>
                    </form>
                </div>
                <div class="col-md-5 offset-md-1 donate__image">
                    <img :src="image" alt="planting" class="card-img-top img-fluid image-responsive">
                </div>
            </div>
        </div>

</template>
<script>
    export default{
        props: {
          'image': {required: false}
        },
        data: function(){
            return {
                formErrors: {},
                showExtraAmount: false,
                formData: {
                    _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    amount: 0,
                    extraAmount: '',
                    name: '',
                    surname: '',
                    address: '',
                    number: '',
                    zipcode: '',
                    addition: '',
                    residence: '',
                    email: '',
                    phone: '',
                },
                dropdownOptions: [
                    { name: '5', value: 5 },
                    { name: '10', value: 10 },
                    { name: '20', value: 20 },
                    { name: '50', value: 50 },
                    { name: 'Anders', value: 'anders' },
                ]
            }
        },
        mounted: function(){
            this.$watch(
                () => {
                    return this.$refs.dropdown.value
                },
                (value) => {
                    this.formData.amount = value.value
                }
            );
            this.setPreFilledInValues();
        },
        methods: {
            setPreFilledInValues: function(){
                this.formData.name = this.findGetParemetersFromUrl('name');
                this.formData.surname = this.findGetParemetersFromUrl('surname');
                this.$refs.dropdown.setValueOnLoad(parseInt(this.findGetParemetersFromUrl('amount')));
            },
            findGetParemetersFromUrl: function(parameterName){
                let result,
                    tmp = [];

                window.location.search
                    .substr(1)
                    .split('&')
                    .forEach(function (item) {
                    tmp = item.split("=");
                    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
                });

                return result;
            },
            checkAmountValue: function(){
                (this.$refs.dropdown.value && this.$refs.dropdown.value.value === 'anders') ? this.showExtraAmount = true : this.showExtraAmount = false;
            },
            validateForm: function(e){
                let _this = this;
                $.post( "/check-donation-form", this.formData)
                    .done(function( data, status ) {
                        $('#donating-form').submit();
                    }).fail(function(data){
                        _this.formErrors = data.responseJSON.errors;
                });
            },
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            }
        }
    }
</script>
<style lang="scss">
    $errorBorder: 1px solid red;
    .error{
        border: $errorBorder !important;
    }
    .select-error .custom-select-opener {
        border: $errorBorder !important;
    }
    .green-border{
        background: #fff;
        border: 2px solid #6eb52e;
        padding-top:10px;
        padding-bottom:10px;
    }

    .double-input-row{
        margin-bottom: 5px !important;
        input{
            display: inline-block;
            /*margin: 0 auto;*/
        }
    }

    .half{
        display: inline-block !important;
    }

    .row-padding{
        padding: 11px 15px 9px;
        margin-bottom: 0 !important;
    }
</style>